import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import Modal from "react-bootstrap/Modal";
import { AnchorComponent, ButtonComponent } from "../elements";
import { Link } from "react-router-dom";

export default function SchoolEnrollmentTable({ thead, tbody }) {
  const { t } = useContext(TranslatorContext);

  const [alertModal, setAlertModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    setData(tbody);
  }, [tbody]);

  /* =========================
     EDIT HANDLER
  ========================== */
  const handleEdit = (item) => {
    setSelectedItem({ ...item });
    setEditModal(true);
  };

  /* =========================
     UPDATE HANDLER
  ========================== */
  const handleUpdate = () => {
    const updatedData = data.map((item) =>
      item.id === selectedItem.id ? selectedItem : item
    );

    setData(updatedData);
    setEditModal(false);
  };

  return (
    <div className="mc-table-responsive">
      <table className="mc-table product">
        <thead className="mc-table-head primary">
          <tr>
            {thead.map((item, index) => (
              <th key={index}>{t(item)}</th>
            ))}
          </tr>
        </thead>

        <tbody className="mc-table-body even">
          {data?.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>

              <td>
                <img
                  src={item.going_image}
                  alt=""
                  width="60"
                  height="60"
                  className="rounded"
                />
              </td>

              <td>{item.f_number}</td>
              <td>{item.student_name}</td>
              <td>{item.dob}</td>
              <td>{item.gender}</td>
              <td>{item.guardian_name}</td>
              <td>{item.cnic}</td>
              <td>{item.religion}</td>
              <td>{item.address}</td>
              <td>{item.contact}</td>

              <td>
                <img
                  src={item.student_image}
                  alt=""
                  width="60"
                  height="60"
                  className="rounded"
                />
              </td>

              <td>{item.school_category}</td>
              <td>{item.school_name}</td>
              <td>{item.level}</td>
              <td>{item.class_name}</td>
              <td>{item.enrollment_date}</td>
              <td>{item.fee}</td>
              <td>{item.cost}</td>
              <td>{item.total}</td>

              <td>
                <a href={item.invoice} target="_blank" rel="noreferrer">
                  View
                </a>
              </td>

              {/* <td>
                <video width="80" controls>
                  <source src={item.video} type="video/mp4" />
                </video>
              </td> */}
{/* 
              <td>
                <div className="mc-table-action">
                  <Link
                    to={`/edit-school-training/${item.id}`}
                    className="material-icons edit"
                  >
                    edit
                  </Link>

                  <Link
                    to={`/school-training/${item.id}`}
                    className="material-icons visibility"
                  >
                    visibility
                  </Link>
                </div>
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>

      {/* ======================
          EDIT MODAL
      ======================= */}
      <Modal show={editModal} onHide={() => setEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Training</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group mb-3">
            <label>Institute Name</label>
            <input
              type="text"
              className="form-control"
              value={selectedItem?.institute_name || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  institute_name: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group mb-3">
            <label>Training Name</label>
            <input
              type="text"
              className="form-control"
              value={selectedItem?.training_name || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  training_name: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group mb-3">
            <label>Duration</label>
            <input
              type="text"
              className="form-control"
              value={selectedItem?.training_duration || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  training_duration: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group mb-3">
            <label>Total Fees</label>
            <input
              type="number"
              className="form-control"
              value={selectedItem?.total_fees || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  total_fees: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group mb-3">
            <label>Status</label>
            <select
              className="form-control"
              value={selectedItem?.status || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  status: e.target.value,
                })
              }
            >
              <option value="pending">Pending</option>
              <option value="completed">Completed</option>
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <ButtonComponent
            type="button"
            className="btn btn-secondary"
            onClick={() => setEditModal(false)}
          >
            {t("close")}
          </ButtonComponent>

          <ButtonComponent
            type="button"
            className="btn btn-primary"
            onClick={handleUpdate}
          >
            {t("update")}
          </ButtonComponent>
        </Modal.Footer>
      </Modal>

      {/* ======================
          DELETE MODAL
      ======================= */}
      <Modal show={alertModal} onHide={() => setAlertModal(false)}>
        <div className="mc-alert-modal">
          <i className="material-icons">new_releases</i>
          <h3>Are you sure?</h3>
          <p>Want to delete this training?</p>

          <Modal.Footer>
            <ButtonComponent
              type="button"
              className="btn btn-secondary"
              onClick={() => setAlertModal(false)}
            >
              {t("close")}
            </ButtonComponent>

            <ButtonComponent
              type="button"
              className="btn btn-danger"
              onClick={() => setAlertModal(false)}
            >
              {t("delete")}
            </ButtonComponent>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
}
